import React, {useEffect, useState} from "react";
import EADialog from "../../EADialog";
import {useForm} from "../../../utils/FormUtils";
import {createWiedervorlageSchema} from "../../../initialObjects/Wiedervorlage";
import EAButtonBar from "../../EAButtonBar";
import EACheckbox from "../../EACheckbox";
import EAButton from "../../EAButton";
import {useHistory} from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import {createDirectLink} from "../../../utils/RouteUtils";

export default function WiedervorlageEditDialog({open, onClose, wiedervorlage, saveUrl = null, showGoTo = false}) {
    const [editMode, setEditMode] = useState(false);
    const [deleteOnClose, setDeleteOnClose] = useState(false);
    const [linkLoading, setLinkLoading] = useState(false);
    const history = useHistory();
    const {formFactory, submit, submitLoading, setValues, setErrors} = useForm({schema: createWiedervorlageSchema(), readonly: editMode});

    useEffect(() => {
        setEditMode(!!wiedervorlage?.id);
    }, [wiedervorlage.id]);

    /**
     * Validierungsfehler zurücksetzten wenn Dialog geöffnet wird
     */
    useEffect(() => {
        setErrors({});
    }, [open, setErrors])

    useEffect(() => {
        if (!open && wiedervorlage.id && deleteOnClose) {
            setDeleteOnClose(false);
        }
    }, [open, wiedervorlage.id, deleteOnClose]);

    useEffect(() => {
        if (open) {
            setValues(wiedervorlage);
        } else {
            setValues(null);
        }
    }, [open, wiedervorlage, setValues]);

    function saveWiedervorlage() {
        submit((v) => v, saveUrl, "POST").then(() => onClose(true));
    }

    function createButtonBar() {
        return (
            <EAButtonBar style={{width: "100%"}}>
                {editMode && (
                    <EACheckbox
                        id="wiedervorlageDelete"
                        style={{marginRight: "auto"}}
                        value={deleteOnClose}
                        onChange={(e) => setDeleteOnClose(e.target.checked)}
                    >
                        Wiedervorlage beim Schließen löschen
                    </EACheckbox>
                )}
                {editMode && <EAButton id="closeDialog" label="Schließen" onClick={() => onClose(deleteOnClose)}/>}
                {!editMode && <EAButton id="saveWiedervorlage" label="Speichern" onClick={() => saveWiedervorlage()}/>}
            </EAButtonBar>
        );
    }

    function createDialogContent() {
        return linkLoading || submitLoading ? (
            <div
                style={{
                    width: "500px",
                    height: "150px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress/>
            </div>
        ) : (
            <div className="gridl" style={{gridTemplateColumns: "200px min-content"}}>
                {formFactory.renderInput("betreff", "wiedervorlageBetreff", "Betreff", "text", false, {
                    style: {gridColumn: "span 2"},
                })}
                {formFactory.renderDatePicker("datum", "wiedervorlageDatum", "Datum", false, {style: {gridColumn: 2}})}
                <div>
                    {showGoTo &&
                    createDirectLink(
                        wiedervorlage.fachobjekt,
                        wiedervorlage.bezugZuFachobjekt,
                        wiedervorlage.fachobjektId,
                        () => {
                            onClose(deleteOnClose, true);
                            setLinkLoading(true);
                        },
                        history
                    )}
                </div>
            </div>
        );
    }

    return (
        <EADialog
            titleChildren={editMode ? "Wiedervorlage ansehen" : "Wiedervorlage erstellen"}
            closeFunction={() => onClose(deleteOnClose)}
            open={open}
            content={createDialogContent()}
            buttons={!linkLoading && !submitLoading && createButtonBar()}
            testId="wiedervorlageDlg"
        />
    );
}
